/**
 * Склонение
 * @param {Number} value — дни
 */
const convertDaysToHours = (numberOfDays) => {
  return numberOfDays * 24;
};

export default convertDaysToHours;
